import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aeadbfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "OkSelect__name"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OkSelect__required" }, "*", -1))
const _hoisted_3 = {
  class: "OkSelect__control",
  ref: "elementref"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выбрано:", -1))
const _hoisted_5 = { class: "OkSelect__icon" }
const _hoisted_6 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 9L12 15L18 9",
  stroke: "#B3B3B3",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "OkSelect__options",
  ref: "optionswindow"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "options__empty"
}
const _hoisted_12 = {
  key: 2,
  class: "OkSelect__error"
}
const _hoisted_13 = { class: "error__text" }
const _hoisted_14 = {
  key: 3,
  class: "options__loader"
}
const _hoisted_15 = {
  key: 1,
  class: "OkSelect__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkSelect", {
            'OkSelect--invalid': _ctx.isInvalid,
            'OkSelect--success': _ctx.success,
            'OkSelect--disabled': _ctx.disabled,
            'OkSelect--opened': _ctx.state.is_opened
        }])
  }, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.required)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
                _hoisted_2
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.name), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "OkSelect__trigger",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(["OkSelect__placeholder", {
                        selected:
                            (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length)) ||
                            (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length)),
                    }])
        }, [
          (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.selectedOption)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.$slots['option'] && _ctx.$slots['selected-option'])
                        ? _renderSlot(_ctx.$slots, "selected-option", {
                            key: 0,
                            option: _ctx.selectedOption
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.selectedOption[_ctx.label]), 1)
                          ], 64))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Выбрано некорректное значение ")
                    ], 64))
              ], 64))
            : (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedOptions.length < 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.$slots['selected-options'])
                          ? _renderSlot(_ctx.$slots, "selected-options", {
                              key: 0,
                              options: _ctx.selectedOptions
                            }, undefined, true)
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_4,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (selected_option, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "ml-2",
                                  key: `selected_option-${i}`
                                }, _toDisplayString(selected_option[_ctx.label]), 1))
                              }), 128))
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Выбрано: " + _toDisplayString(_ctx.selectedOptions.length), 1)
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                ], 64))
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.searchable)
          ? (_openBlock(), _createBlock(_component_ok_input, {
              key: 0,
              autocomplete: false,
              placeholder: "Поиск",
              value: _ctx.state.search_query,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.search_query) = $event)),
              onInput: _ctx.searchOption
            }, null, 8, ["value", "onInput"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["options__option", {
                        active:
                            (!_ctx.multiselect && _ctx.value === option[_ctx.selectBy]) ||
                            (_ctx.multiselect && _ctx.value.includes(option[_ctx.selectBy])),
                    }]),
            key: `option-${i}`,
            onClick: ($event: any) => (_ctx.emitSelect(option[_ctx.selectBy]))
          }, [
            (_ctx.$slots['option'])
              ? _renderSlot(_ctx.$slots, "option", {
                  key: 0,
                  option: option
                }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(option[_ctx.label]), 1)
                ], 64))
          ], 10, _hoisted_10))
        }), 128)),
        (_ctx.state.items.length === 0 && !_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.emptyText), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.errorText), 1),
              _createVNode(_component_ok_button, { onClick: _ctx.emitRefresh }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перезагрузить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ], 512),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ], 2))
}